import api, { handleResponse } from "../queries/api";
import { CustomResponse } from "../types/user";

const getPlatformBasePath = () => "/platform";

export interface PlatformUser {
  id: string;
  name: string;
  email: string;
  role: string;
  company?: string | null;
  phone?: string | null;
  deactivated: boolean;
  createdAt: string;
  client?: { id: string; name: string } | null;
}

export interface PlatformOrganisation {
  id: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  createdAt: string;
  _count: { users: number; locations: number; devices: number };
}

export interface PlatformLocation {
  id: string;
  name: string;
  address?: string | null;
  createdAt: string;
  client?: { id: string; name: string } | null;
  _count: { devices: number };
}

export interface PlatformDevice {
  id: string;
  name: string;
  identifier?: string | null;
  modelType?: string | null;
  status?: string | null;
  createdAt: string;
  location?: { id: string; name: string } | null;
  client?: { id: string; name: string } | null;
}

export async function getPlatformUsers(): Promise<CustomResponse<PlatformUser[]>> {
  return api.get(`${getPlatformBasePath()}/users`).then(handleResponse);
}

export async function getPlatformOrganisations(): Promise<
  CustomResponse<PlatformOrganisation[]>
> {
  return api.get(`${getPlatformBasePath()}/organisations`).then(handleResponse);
}

export async function getPlatformLocations(): Promise<CustomResponse<PlatformLocation[]>> {
  return api.get(`${getPlatformBasePath()}/locations`).then(handleResponse);
}

export async function getPlatformDevices(): Promise<CustomResponse<PlatformDevice[]>> {
  return api.get(`${getPlatformBasePath()}/devices`).then(handleResponse);
}

export async function setPlatformUserStatus(
  userId: string,
  deactivated: boolean,
): Promise<CustomResponse<PlatformUser>> {
  return api
    .put(`${getPlatformBasePath()}/users/${userId}/status`, { deactivated })
    .then(handleResponse);
}
